<template>
    <div class="flex flex-col gap-5 p-3">
      <div class="text-center">
        <h4 class="text-md font-bold">Charges</h4>
      </div>
      <div class="flex flex-col gap-5">
        <p class="text-sm">This includes the delivery fees and packaging charges from all sellers for the items in your order</p>
        <div class="flex justify-center ">
          <div class="w-1/2">
            <UButton size="xl" label="Got it" variant="solid" block @click="emit('close')"/>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  const emit = defineEmits(['close']);
  
  </script>
  